export const canGoForward = (currentPage: number, pageCount: number): boolean => {
    return currentPage < pageCount;
  };